import { myMessage } from "./message";

export const uploadPicture = (path, type, callBack) => {
  // 压缩图片
  plus.zip.compressImage(
    {
      src: path, //src在这里是第一步Url里的src。也就是本地路径
      dst: "_doc/a.jpg",
      quality: 20,
      overwrite: true
    },
    function(e) {
      upload(e.target); //压缩图片
    },
    function(err) {
      console.log(err);
    }
  );

  function upload(path) {
    var task = plus.uploader.createUpload(
      window.config.url + "api/oss/upload",
      { method: "POST", blocksize: 204800, priority: 100 },
      function(t, status) {
        console.log("上传图片打印:" + JSON.stringify(t), status);
        // 上传完成
        if (status == 200) {
          var data = JSON.parse(t.responseText);

          callBack(data);
          // 移除缓存文件
          plus.io.resolveLocalFileSystemURL(path, function(entry) {
            entry.remove(
              function(entry) {
                console.log("临时文件删除成功" + path);
              },
              function(e) {
                console.log("临时文件删除失败" + path);
              }
            );
          });
        } else {
          myMessage(error.message);
        }
      }
    );
    task.addFile(path, { key: "file" });
    task.addData("type", type ? type : "common");
    task.start();
  }
};

//获取用户手机号

export const getPhone = () => {
  return new Promise((resolve, reject) => {
    let phoneNumber = "";
    let permissions = ["android.permission.READ_PHONE_STATE"];
    plus.android.requestPermissions(permissions, function(result) {
      if (result["granted"][0] == "android.permission.READ_PHONE_STATE") {
        let telephonyManager = plus.android.importClass(
          "android.telephony.TelephonyManager"
        );
        let context = plus.android.runtimeMainActivity();
        let telephony = context.getSystemService(context.TELEPHONY_SERVICE);
        phoneNumber = telephony.getLine1Number()
          ? telephony.getLine1Number()
          : "";
        resolve(phoneNumber);
        // 处理手机号
      } else {
        reject();
        // 用户拒绝了权限请求
      }
    });
  });
};

//获取用户唯一id
export const getPhoneId = () => {
  return new Promise((resolve, reject) => {
    plus.device.getInfo({
      success: function(e) {
        resolve(e.uuid);
      },
      fail: function (e) {
        myMessage(e.message);
      }
    });
  });
};

let coords = {};
let timeout5 = null;

//获取用户所在经纬度
export const getGeolocation = () => {
  return new Promise((resolve, reject) => {
    if (coords.latitude) {
      if (timeout5) {
        clearTimeout(timeout5);
      }
      resolve(coords);
      timeout5 = setTimeout(() => {
        coords = {};
      }, 1000 * 10);
      return;
    }
    if (navigator.geolocation) {
      try {
        navigator.geolocation.getCurrentPosition(
          function(p) {
            coords = p.coords;
            resolve(p.coords);
          },
          function(e) {
            resolve({ latitude: 0, longitude: 0 });
            // myMessage("獲取位置信息錯誤！");
          },
          {
            maximumAge: 60000, // 接受的缓存位置的最大年龄为60000毫秒（1分钟）
            timeout: 20000, // 10秒超时时间
            enableHighAccuracy: true // 请求高精度位置
          }
        );
      } catch (error) {
        resolve({ latitude: 0, longitude: 0 });
        // myMessage("獲取位置信息錯誤!");
      }
    } else {
      resolve({ latitude: 0, longitude: 0 });
      myMessage("Geolocation is not supported by this browser.");
    }
    // 经纬度测试
    // plus.geolocation.getCurrentPosition(
    //   function(p) {
    //     try {
    //       resolve(p.coords);
    //     } catch (error) {
    //       reject();
    //       myMessage(error);
    //     }
    //   },
    //   function(e) {
    //     reject();
    //     myMessage(e.message);
    //   },
    //   {
    //     enableHighAccuracy: true,
    //     timeout: 1000 * 10,
    //     maximumAge: 200,
    //     provider: "system"
    //   }
    // );
  });
};

//获取用户唯一id
export const getGalleryImg = options => {
  return new Promise((resolve, reject) => {
    plus.gallery.pick(
      function(e) {
        resolve(e);
      },
      function(e) {
        myMessage(e.message);
      },
      options
    );
  });
};

export const getToken = () => {
  return window.plus
    ? plus.storage.getItem("token")
    : localStorage.getItem("token");
};

export const clearToken = () => {
  return window.plus
    ? plus.storage.removeItem("token")
    : localStorage.removeItem("token");
};

export const getStorageItem = name => {
  return window.plus ? plus.storage.getItem(name) : localStorage.getItem(name);
};

export const setStorageItem = (name, value) => {
  return window.plus
    ? plus.storage.setItem(name, value)
    : localStorage.setItem(name, value);
};

export function getNetworkStatus() {
  let networkinfo = plus.networkinfo;
  let types = {};
  types[networkinfo.CONNECTION_UNKNOW] = "Unknown";
  types[networkinfo.CONNECTION_NONE] = "None";
  types[networkinfo.CONNECTION_ETHERNET] = "Ethernet";
  types[networkinfo.CONNECTION_WIFI] = "WiFi";
  types[networkinfo.CONNECTION_CELL2G] = "2G";
  types[networkinfo.CONNECTION_CELL3G] = "3G";
  types[networkinfo.CONNECTION_CELL4G] = "4G";

  let networkType = networkinfo.getCurrentType();
  let status = types[networkType] || "Unknown";

  return status;
}

export function updateNetworkStatus() {
  let status = getNetworkStatus();

  if (status === "None") {
    console.log("No network");
    return 1;
  } else if (status === "Unknown" || status === "2G" || status === "3G") {
    console.log("Poor network signal");
    return 2;
  } else {
    console.log("Network is available");
    return 3;
  }
}



// WEBPACK FOOTER //
// ./src/utils/h5Plus.js